import { FC, useState } from 'react';
import { MeetingAssignmentsModal } from './MeetingAssignmentsModal';
import { typeMeeting } from '@monorepo/models';
import { useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    label: string;
    meetings: typeMeeting[];
};

export const MeetingAssignmentsButton: FC<propsType> = ({ label, meetings }) => {
    const [showUserAssignments, setShowUserAssignments] = useState(false);
    const isMobile = useGetIsMobile();

    return (
        <>
        {showUserAssignments &&
            <MeetingAssignmentsModal
                closeModal={() => setShowUserAssignments(false)}
                label={label}
                meetings={meetings}
            />
        }
        <div className={'hide-for-navbar'} style={{ position: 'fixed', width: '100%', zIndex: 4 }}>
            <div
                style={{
                    right: isMobile ? '20px' : '0',
                    marginTop: '155px',
                    position: 'fixed',
                    top: 0,
                    transform: isMobile ? '' : 'translateX(-50%)',
                    zIndex: 3
                }}
            >
                <button className={`btn btn-general-blue d-block ${isMobile ? 'btn-sm' : ''}`}
                    style={{ width: '140px' }}
                    onClick={() => setShowUserAssignments(true)}
                >
                    Ver por Reunión
                </button>
            </div>
        </div>
        </>
    );
}
